<script>
export default {
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#2F54EB'
    }
  }
}
</script>
<template>
  <svg
    :width="size"
    height="auto"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M11.3332 1.3335H4.6665C4.11422 1.3335 3.6665 1.78121 3.6665 2.3335V13.6668C3.6665 14.2191 4.11422 14.6668 4.6665 14.6668H11.3332C11.8855 14.6668 12.3332 14.2191 12.3332 13.6668V2.3335C12.3332 1.78121 11.8855 1.3335 11.3332 1.3335Z"
        :stroke="color"
        stroke-width="1.33333"
      />
      <path
        id="Vector_2"
        d="M7.3335 3.3335H8.66683"
        :stroke="color"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M6.6665 12.6665H9.33317"
        :stroke="color"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
